// 圖片重上色工具：把成熟美術素材（單色剪影或漸層彩色）依指定顏色重新著色，
// 供 FallingPetalsImage / FallingPetalsCanvas / FallingPetalsThree 共用。

function hexToRgb(hex) {
    return [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
}

function mixColor(c1, c2, t) {
    return c1.map((v, i) => Math.round(v + (c2[i] - v) * t));
}

function loadImage(src) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
    });
}

/**
 * 用 canvas 的 source-in 疊色技巧，把單色剪影圖整片重新上色成指定顏色。
 * 回傳已上色完成的 <canvas> 元素（可直接 drawImage 或轉 dataURL）。
 */
export async function recolorFlat(imageSrc, color) {
    const img = await loadImage(imageSrc);
    const canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    ctx.globalCompositeOperation = 'source-in';
    ctx.fillStyle = color;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    return canvas;
}

/**
 * 依原圖 R 通道亮度重建漸層（保留花心深、瓣尖淺的立體層次），套用到指定主色；
 * 描邊（原圖鮮紅色、G 通道很低）另外上更深的同色系，維持花瓣輪廓分離感。
 * 色票本身越淺，混白/混黑的幅度會自動收斂，避免淺色系「掉色」洗白。
 * 回傳已上色完成的 <canvas> 元素。
 */
export async function recolorGradient(imageSrc, color) {
    const img = await loadImage(imageSrc);
    const canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    const base = hexToRgb(color);
    const white = [255, 255, 255];
    const black = [25, 15, 10];
    const luminance = (base[0] * 0.299 + base[1] * 0.587 + base[2] * 0.114) / 255;
    const lightMix = 0.55 * (1 - luminance * 0.75);
    const darkMix = 0.45 * (1 - luminance * 0.4);
    const dark = mixColor(base, black, darkMix);
    const light = mixColor(base, white, lightMix);
    const stroke = mixColor(base, black, Math.min(0.72, darkMix + 0.27));
    const lo = 60;
    const hi = 255;

    for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const a = data[i + 3];
        if (a === 0) continue;
        if (g < 20 && r > 150) {
            data[i] = stroke[0];
            data[i + 1] = stroke[1];
            data[i + 2] = stroke[2];
        } else {
            const t = Math.max(0, Math.min(1, (r - lo) / (hi - lo)));
            data[i] = dark[0] + (light[0] - dark[0]) * t;
            data[i + 1] = dark[1] + (light[1] - dark[1]) * t;
            data[i + 2] = dark[2] + (light[2] - dark[2]) * t;
        }
    }
    ctx.putImageData(imageData, 0, 0);
    return canvas;
}
